import React from 'react'

export default props => {
  return (
    <div>
      <label>{props.label}</label>
      <input
        type={props.type}
        placeholder={props.placeholder}
        value={props.value}
        onChange={(evt) => props.onChange(props.name, evt.target.value)}
      />
    </div>
  )
}